let ciklusi_staro = [
  [
    { fajl: "RS-Mar-12-2018-4405-Lowres.jpg", naziv: "Abysses" },
    { fajl: "RS-Mar-12-2018-4402-Lowres.jpg", naziv: "Meander" },
    { fajl: "RS-Mar-11-2018-4374.jpg" }
  ],
  [{ fajl: "RS-Mar-06-2018-4057.jpg" }, { fajl: "RS-Mar-06-2018-4155.jpg" }],
  [
    { fajl: "RS-Mar-06-2018-4012.jpg" },
    { fajl: "RS-Mar-06-2018-4016.jpg" },
    { fajl: "RS-Mar-06-2018-4019.jpg" },
    { fajl: "RS-Mar-06-2018-4110.jpg" }
  ],
  [{ fajl: "RS-Mar-11-2018-4379.jpg" }, { fajl: "background4.jpg" }],
  [
    { fajl: "RS-Mar-07-2018-4239.jpg" },
    { fajl: "background5.jpg" },
    { fajl: "RS-Mar-07-2018-4230.jpg" },
    { fajl: "RS-Mar-11-2018-4355.jpg" }
  ],
  [
    { fajl: "RS-Mar-06-2018-4143.jpg" },
    { fajl: "RS-Mar-06-2018-4046 With Frame.jpg" },
    { fajl: "RS-Mar-06-2018-4051.jpg" }
  ]
];

let ciklusi = [
  [
    { fajl: "1/RS-Mar-12-2018-4405.jpg" },
    { fajl: "1/DSC_0042.jpg" },
    { fajl: "1/DSC_0039.jpg" }
  ],
  [
    { fajl: "2/RS-Mar-06-2018-4012 copy.jpg" },
    { fajl: "2/RS-Mar-06-2018-4012.jpg" },
    { fajl: "2/RS-Mar-06-2018-4016.jpg" },
    { fajl: "2/RS-Mar-06-2018-4019.jpg" },
    { fajl: "2/RS-Mar-06-2018-4022.jpg" },
    { fajl: "2/RS-Mar-06-2018-4046.jpg" },
    { fajl: "2/RS-Mar-06-2018-4051.jpg" }
  ],
  [
    { fajl: "3/DSC_5506.a.jpg" },
    { fajl: "3/DSC_0112.jpg" },
    { fajl: "3/FINAL__JAY4654.jpg" }
  ],
  [{ fajl: "4/DSC_0357-obradjeni1-bela-pozadina.jpg" }],
  [
    { fajl: "5/_JAY5924©JayAlonzo-Screen.jpg" },
    { fajl: "5/RS-Mar-06-2018-4068.jpg" },
    { fajl: "5/RS-Mar-06-2018-4130.jpg" }
  ],
  [{ fajl: "6/DSC_0005.jpg" }, { fajl: "6/_JAY5871©JayAlonzo-Screen.jpg" }],
  [
    { fajl: "7/DSC_4447-.jpg" },
    { fajl: "7/DSC_4500.jpg" },
    { fajl: "7/RS-Mar-11-2018-4355.jpg" },
    { fajl: "7/RS-Mar-11-2018-4398.jpg" }
  ]
];

export default ciklusi;
